import './scss/fieldeditor.scss'
import {FieldEditorComponent} from './FieldEditorComponent'

const FieldEditorPackage = {
    name: 'UIFieldEditor',
    configure: function(config) {
        config.addComponent('UIFieldEditor', FieldEditorComponent, false, 'field-editor')
    }
}

export {FieldEditorPackage}
